

document.addEventListener("turbo:load", function() {
  const SuccessOverlay = $("#js-toggle-success-overlay")
  const DeniedOverlay = $("#js-toggle-denied-overlay")

  if (SuccessOverlay.length > 0) {
    SuccessOverlay.on("click", function () {
      $("#js-temporary-user-overlay").remove();
      $("#js-bewerbung-net-overlay-success").addClass( "finishing-overlay-card--finish-active");
    });

    $("#js-bewerbung-net-success-overlay-close").on("click", function () {
      $("#js-bewerbung-net-overlay-success").removeClass( "finishing-overlay-card--finish-active");
    });
  }

  if (DeniedOverlay.length > 0) {
    DeniedOverlay.on("click", function () {
      $("#js-temporary-user-overlay").remove();
      $("#js-bewerbung-net-overlay-denied").addClass( "finishing-overlay-card--denied-active");
    });

    $("#js-bewerbung-net-denied-overlay-close").on("click", function () {
      $("#js-bewerbung-net-overlay-denied").removeClass( "finishing-overlay-card--denied-active");
    });

  }


})
